const calccat = {
    en: {
        "calccat.title": "Dealer price categories",
        "calccat.hint": "Markups added to base transport prices for dealers in each category.",
        "calccat.code": "Code",
        "calccat.label": "Label",
        "calccat.landMarkup": "Land markup",
        "calccat.containerMarkup": "Container markup",
        "calccat.add": "Add category",
        "calccat.save": "Save",
        "calccat.delete": "Delete",
        "calccat.none": "No categories yet",
        "calccat.confirmDelete": "Delete this category?",
    },
    ru: {
        "calccat.title": "Ценовые категории дилеров",
        "calccat.hint": "Наценки к базовым ценам перевозки для дилеров каждой категории.",
        "calccat.code": "Код",
        "calccat.label": "Название",
        "calccat.landMarkup": "Наценка (земля)",
        "calccat.containerMarkup": "Наценка (контейнер)",
        "calccat.add": "Добавить категорию",
        "calccat.save": "Сохранить",
        "calccat.delete": "Удалить",
        "calccat.none": "Категорий пока нет",
        "calccat.confirmDelete": "Удалить эту категорию?",
    },
    geo: {
        "calccat.title": "დილერების ფასის კატეგორიები",
        "calccat.hint": "ზედნადები ბაზის ტრანსპორტირების ფასებზე თითოეული კატეგორიის დილერისთვის.",
        "calccat.code": "კოდი",
        "calccat.label": "სახელი",
        "calccat.landMarkup": "ზედნადები (მიწა)",
        "calccat.containerMarkup": "ზედნადები (კონტეინერი)",
        "calccat.add": "კატეგორიის დამატება",
        "calccat.save": "შენახვა",
        "calccat.delete": "წაშლა",
        "calccat.none": "კატეგორიები ჯერ არ არის",
        "calccat.confirmDelete": "წავშალო ეს კატეგორია?",
    },
};

export default calccat;
